<template>
  <div>
    <div class="market-box">
      <div class="all-box">
        <div class="left-box">
          <div
            class="left-item-box"
            :class="{ sel: currType === 'overview' }"
            @click="typeChange('overview')"
          >
            <img
              class="icon-de"
              v-if="currType === 'overview'"
              src="@/assets/img/images/icon/wallet-icon-all-s.png"
              alt=""
            />
            <img
              class="icon-de"
              v-else
              src="@/assets/img/images/icon/wallet-icon-all.png"
              alt=""
            />
            <p>{{ $t("asset.overview") }}</p>
          </div>
          <div
            class="left-item-box"
            :class="{ sel: currType === 'rwa' }"
            @click="typeChange('rwa')"
          >
            <img
              class="icon-de"
              v-if="currType === 'rwa'"
              src="@/assets/img/images/icon/wallet-icon1-s.png"
              alt=""
            />
            <img
              class="icon-de"
              v-else
              src="@/assets/img/images/icon/wallet-icon1.png"
              alt=""
            />
            <p>{{ $t("asset.rwa_token") }}</p>
          </div>
          <div
            class="left-item-box"
            :class="{ sel: currType === 'fund' }"
            @click="typeChange('fund')"
          >
            <img
              class="icon-de"
              v-if="currType === 'fund'"
              src="@/assets/img/images/icon/wallet-icon2-s.png"
              alt=""
            />
            <img
              class="icon-de"
              v-else
              src="@/assets/img/images/icon/wallet-icon2.png"
              alt=""
            />
            <p>{{ $t("asset.fund") }}</p>
          </div>
        </div>
        <div
          class="right-box"
          v-loading="loading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="total-asset-card">
            <div class="asset-header-box">
              <div class="asset-header">
                <span class="asset-label">{{ $t("asset.overview") }}</span>
              </div>
              <div class="action-buttons">
                <div class="action-btn primary" @click="goRecharge">
                  <span class="btn-text">{{ $t("asset.recharge") }}</span>
                </div>
                <div class="action-btn secondary" @click="goWithdraw">
                  <span class="btn-text">{{ $t("asset.withdraw") }}</span>
                </div>
                <div class="action-btn secondary" @click="goRecords">
                  <span class="btn-text">{{ $t("asset.records") }}</span>
                </div>
              </div>
            </div>

            <div class="assets-total-box mt20">
              <div class="assets-total-item">
                <p>
                  {{ $t("asset.estimated_total_assets") }}
                  <img
                    v-if="showAssets"
                    @click="showAssets = !showAssets"
                    src="@/assets/img/images/home/eye.png"
                    alt=""
                    srcset=""
                  />
                  <img
                    v-else
                    @click="showAssets = !showAssets"
                    src="@/assets/img/images/home/eye2.png"
                    alt=""
                    srcset=""
                  />
                </p>
                <div class="asset-amount">
                  <span class="amount-value">{{ showAssets ? totalAssetsDisplay : "******" }}
                  </span>
                  <div
                    class="currency-selector"
                    @click.stop="toggleCurrencyPicker"
                  >
                    <span class="amount-currency"> {{ legalCurrency }}</span>
                    <i class="el-icon-caret-bottom" />
                    <div class="currency-dropdown" v-if="showCurrencyPicker">
                      <div
                        class="currency-option"
                        :class="{ active: legalCurrency === 'HKD' }"
                        @click.stop="selectCurrency('HKD')"
                      >
                        <span class="currency-text">HKD</span>
                      </div>
                      <div
                        class="currency-option"
                        :class="{ active: legalCurrency === 'USD' }"
                        @click.stop="selectCurrency('USD')"
                      >
                        <span class="currency-text">USD</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ml40" />
              <div class="assets-total-item">
                <p>
                  {{ $t("home.v2.quotes.todayPnl") }}
                </p>
                <div class="p-info">
                  <span class="pnl-value" :style="{ color: pnlColor }">{{
                    pnlValueDisplay
                  }}</span>
                  <span class="pnl-rate" :style="{ color: pnlColor }">{{
                    pnlRateDisplay
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <OverviewSection
            v-if="currType === 'overview'"
            :overview-data="overviewData"
            :legal-currency="legalCurrency"
            @change-tab="typeChange"
          />

          <RWASection
            v-else-if="currType === 'rwa'"
            :assets="rwaAssets"
            @select-asset="showActionMenu"
          />

          <FundSection
            v-else-if="currType === 'fund'"
            :assets="fundAssets"
            @select-asset="showActionMenu"
          />

          <!-- HKD兑换卡片 - 仅在资金Tab显示，每个币种一张卡片 -->
          <template v-if="currType === 'fund'">
            <div
              class="exchange-card"
              v-for="(rate, index) in exchangeRates"
              :key="index"
            >
              <div class="exchange-content">
                <p class="exchange-title">
                  {{
                    $t("asset.exchange_hkd_to_ht", {
                      base: rate.base,
                      coin: rate.coin,
                    })
                  }}
                </p>
                <div class="exchange-rate">
                  <span class="exchange-rate-text"
                    >1 {{ rate.base }} = {{ rate.rate }} {{ rate.coin }}</span
                  >
                </div>
                <div class="exchange-footer">
                  <span
                    class="exchange-record"
                    @click="goExchangeRecord(rate)"
                    >{{
                      $t("asset.exchange_record", { coin: rate.coin })
                    }}</span
                  >
                  <div class="exchange-btn" @click="goExchangePage(rate)">
                    <span class="exchange-btn-text">{{
                      $t("asset.go_now")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <VFooter />
    <QuestionPopup />
    <ChargingDialog v-if="currentAsset" ref="chargingDialogRef" />
    <ChargingHKDDialog v-if="currentAsset" ref="chargingHKDDialogRef" />
    <WithdrawDialog v-if="currentAsset" ref="withdrawDialogRef" />
    <MarketLogDialog ref="marketLogDialogRef" />
    <ExchangeRecordDialog ref="exchangeRecordDialogRef" />
    <ExchangeHKDDialog
      ref="exchangeHKDDialogRef"
      @success="onExchangeSuccess"
    />
    <AssetDetailDialog
      :asset="currentAsset"
      :visible="showDetailDialog"
      @update:visible="showDetailDialog = $event"
      @recharge="handleDetailRecharge"
      @withdraw="handleDetailWithdraw"
      @records="handleDetailRecords"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import VFooter from "@/components/footer/VFooter";
import QuestionPopup from "@/components/QuestionPopup/index";
import ChargingDialog from "./components/ChargingDialog";
import ChargingHKDDialog from "./components/ChargingHKDDialog";
import WithdrawDialog from "./components/WithdrawDialog";
import MarketLogDialog from "./components/MarketLogDialog";
import AssetDetailDialog from "./components/AssetDetailDialog";
import ExchangeRecordDialog from "./components/ExchangeRecordDialog";
import ExchangeHKDDialog from "./components/ExchangeHKDDialog";
import OverviewSection from "./components/OverviewSection";
import RWASection from "./components/RWASection";
import FundSection from "./components/FundSection";
export default {
  components: {
    VFooter,
    QuestionPopup,
    ChargingDialog,
    ChargingHKDDialog,
    WithdrawDialog,
    MarketLogDialog,
    AssetDetailDialog,
    ExchangeRecordDialog,
    ExchangeHKDDialog,
    OverviewSection,
    RWASection,
    FundSection,
  },
  data() {
    return {
      showAssets: true,
      currType: "overview",
      loading: false,
      userAssets: {},
      tableData: [],
      currentAsset: {},
      legalCurrency: "HKD",
      showCurrencyPicker: false,
      showDetailDialog: false,
      exchangeRates: [],
      overviewData: {
        totalAssets: 0,
        profit: 0,
        profitRate: "+0.00%",
        rwaTokens: 0,
        funds: 0,
      },
      totalAssetCurrency: "",
      legalCurrency: "HKD",
      showCurrencyPicker: false,
      pnlData: null, // 盈亏数据
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
    totalAssetsDisplay() {
      // if (!this.isLogin) return "******";
      if (this.totalAssetCurrency === "" || this.totalAssetCurrency == null) {
        return "--";
      }
      return this.totalAssetCurrency;
    },
    isLogin() {
      return !!(this.user.username && window.localStorage.getItem("jwt-token"));
    },
    rwaAssets() {
      return this.tableData.filter(
        (item) => item.assetType !== "USDT" && item.assetType !== "HKD",
      );
    },
    fundAssets() {
      return this.tableData.filter(// || item.assetType === "HKD"
        (item) => item.assetType === "USDT",
      );
    },
    // 盈亏额显示：+5,800.50 / -5,800.50 / 0.00
    pnlValueDisplay() {
      if (!this.pnlData) return "--";
      const val = Number(this.pnlData.profitValue || 0);
      const formatted = Math.abs(val).toFixed(2);
      const prefix = formatted >= 0 ? "+" : "-";
      return prefix + formatted + " " + this.legalCurrency;
    },
    // 盈亏比例显示：+4.83% / -4.83% / --
    pnlRateDisplay() {
      if (!this.pnlData) return "--";
      if (this.pnlData.profitRate == null) return "--";
      const val = Number(this.pnlData.profitRate);
      const prefix = val > 0 ? "+" : "";
      return prefix + val.toFixed(2) + "%";
    },
    // 盈亏颜色：涨绿、跌红、0灰
    pnlColor() {
      if (!this.pnlData) return "#999999";
      const val = Number(this.pnlData.profitValue || 0);
      const formatted = Math.abs(val).toFixed(2);
      if (formatted >= 0) return "#52C18E";
      if (formatted < 0) return "#F04545";
      return "#999999";
    },
  },
  created() {
    this.loadAssetData();
    this.getExchangeRates();
    if (this.isLogin) {
      this.getTotalAssets();
      this.getProfitLoss();
    }
  },
  methods: {
    typeChange(val) {
      if (this.currType === val) return;
      this.loading = true;
      this.currType = val;
      this.$nextTick(() => {
        this.loadAssetData();
        if (val === "fund") {
          this.getExchangeRates();
        }
      });
    },
    toggleCurrencyPicker() {
      this.showCurrencyPicker = !this.showCurrencyPicker;
    },
    selectCurrency(currency) {
      if (this.legalCurrency !== currency) {
        this.legalCurrency = currency;
        this.loadAssetData();
      }
      this.showCurrencyPicker = false;
      this.$forceUpdate();
      // 切换币种后重新拉取总资产和盈亏
      if (this.isLogin) {
        this.totalAssetCurrency = "";
        this.pnlData = null;
        this.getTotalAssets();
        this.getProfitLoss();
      }
    },
    // 获取总资产
    getTotalAssets() {
      this.$axios
        .post("/userAssets/queryAssetList", {
          accountType: "spot",
          legalCurrency: this.legalCurrency,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.totalAssetCurrency = res.data.data.totalAssetCurrency;
          }
        });
    },
    // 获取今日盈亏
    getProfitLoss() {
      this.$axios
        .post("/userAssets/assetProfitLoss", {
          legalCurrency: this.legalCurrency,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.pnlData = res.data.data || null;
          }
        })
        .catch(() => {
          this.pnlData = null;
        });
    },
    async loadAssetData() {
      this.loading = true;
      try {
        const res = await this.$axios.post("/userAssets/queryAssetList", {
          accountType: "spot",
          legalCurrency: this.legalCurrency,
        });
        if (
          res.data.code === this.errorCode.ok &&
          res.data.data &&
          res.data.data.userAssetRsps
        ) {
          this.userAssets = res.data.data;
          this.tableData = res.data.data.userAssetRsps;

          let totalAssets = 0;
          let rwaTokens = 0;
          let funds = 0;

          this.tableData.forEach((item) => {
            const assetCurrency = parseFloat(item.assetCurrency) || 0;
            totalAssets += assetCurrency;

            if (item.assetType === "USDT" || item.assetType === "HKD") {
              funds += assetCurrency;
            } else {
              rwaTokens += assetCurrency;
            }
          });

          let displayTotal = totalAssets;
          if (this.currType === "rwa") {
            displayTotal = rwaTokens;
          } else if (this.currType === "fund") {
            displayTotal = funds;
          }

          this.overviewData = {
            totalAssets: displayTotal.toFixed(2) || 0,
            profit: 0,
            profitRate: "+0.00%",
            rwaTokens: rwaTokens.toFixed(2) || 0,
            funds: funds.toFixed(2) || 0,
          };
        }
      } catch (error) {
        console.error("Failed to fetch asset data:", error);
      } finally {
        this.loading = false;
      }
    },
    showActionMenu(data) {
      this.currentAsset = data;
      this.showDetailDialog = true;
    },
    handleDetailRecharge(asset) {
      this.currentAsset = asset;
      if (asset.assetType === "HKD") {
        this.addHKDCoin();
      } else {
        this.addCoins();
      }
    },
    handleDetailWithdraw(asset) {
      this.currentAsset = asset;
      this.withdrawCoins();
    },
    handleDetailRecords(asset) {
      this.currentAsset = asset;
      this.$refs.marketLogDialogRef.initDialog(asset.assetType);
    },
    toMallDetail() {
      this.$axios
        .post("/cms/getDetail", {
          cateCode: this.currentAsset.assetType,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok && res.data.data) {
            this.$router.push({
              path: "/mall/oldDetail",
              query: { cateCode: this.currentAsset.assetType },
            });
          } else {
            this.$message.warning(this.$t("asset.no_mall_detail"));
          }
        });
    },
    addCoins() {
      if (this.currentAsset.canRecharge === -1) {
        this.$message.warning(this.$t("asset.can_not_recharge"));
        return false;
      }
      this.$refs.chargingDialogRef.init(this.currentAsset);
    },
    addHKDCoin() {
      this.$refs.chargingHKDDialogRef.init(this.currentAsset);
    },
    withdrawCoins() {
      if (this.currentAsset.canWithdraw === -1) {
        this.$message.warning(this.$t("asset.can_not_withdraw"));
        return false;
      }
      if (!this.judgeValidateNum()) {
        return false;
      }
      if (this.user.statusKycLevel !== 1) {
        this.$message.warning(this.$t("tipsVal.userAuthenticate"));
        return false;
      }
      if (this.user.tranPassword === -1) {
        this.$confirm(
          this.$t("partner.need_set_password"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("partner.set_now"),
            cancelButtonText: this.$t("partner.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            this.$router.push({ path: "/user" });
          })
          .catch(() => {});
      } else {
        this.$refs.withdrawDialogRef.init(this.currentAsset);
      }
    },
    judgeValidateNum() {
      let sum = 0;
      if (this.user.phoneSecurity === 1) sum++;
      if (this.user.emailSecurity === 1) sum++;
      if (this.user.googleSecurity === 1) sum++;
      if (sum >= 2) {
        return true;
      } else {
        this.$message.warning(this.$t("tipsVal.validate_warning"));
        return false;
      }
    },
    goRecharge() {
      this.currentAsset = { assetType: "USDT" };
      this.$refs.chargingDialogRef.init({ assetType: "USDT" });
    },
    goWithdraw() {
      this.currentAsset = { assetType: "USDT" };
      this.$refs.withdrawDialogRef.init({ assetType: "USDT" });
    },
    goRecords() {
      this.$refs.marketLogDialogRef.initDialog();
    },
    goExchangePage(rate) {
      this.$refs.exchangeHKDDialogRef.initDialog(rate);
    },
    onExchangeSuccess() {
      this.loadAssetData();
      this.getExchangeRates();
    },
    goExchangeRecord(rate) {
      const coin = rate && rate.coin ? rate.coin : "";
      this.$refs.exchangeRecordDialogRef.initDialog(coin);
    },
    async getExchangeRates() {
      try {
        const res = await this.$axios.post(
          "/userAssets/depositHKDExchangeRate",
          {},
        );
        if (
          res.data.code === this.errorCode.ok &&
          Array.isArray(res.data.data)
        ) {
          this.exchangeRates = res.data.data;
        }
      } catch (e) {
        console.error("获取兑换汇率失败", e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.market-box {
  position: relative;
  background: var(--bg-color);
  padding: 60px var(--spacing-60) 120px var(--spacing-60);
  .all-box {
    gap: 28px;
    display: flex;
    .left-box {
      padding: 40px;
      width: 320px;
      gap: 16px;
      height: fit-content;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      border-radius: 16px;
      border: 1px solid var(--border-color);
      .left-item-box {
        gap: 20px;
        display: flex;
        cursor: pointer;
        padding: 20px 24px;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #666666;
        border-radius: 12px;
        transition: all 0.3s;
      }
      .sel {
        font-weight: 600;
        font-size: 18px;
        color: var(--primary-color);
        background: var(--primary-bg-color);
      }
    }
    .right-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }
}

.total-asset-card {
  padding: 40px;
  border-radius: 14px;
  background-color: var(--box-bg-color);
  .asset-header-box {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    justify-content: space-between;
    border-bottom: 1px solid var(--line-border-color);
    .asset-label {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 24px;
      color: #1f2329;
      margin-right: 8px;
    }
    .action-buttons {
      display: flex;
      gap: 12px;

      .action-btn {
        padding: 12px 28px;
        border-radius: 10px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s;
        &.primary {
          background-color: var(--primary-color);
          .btn-text {
            color: #ffffff;
            font-weight: 600;
          }
        }
        &.secondary {
          border: 1px solid var(--primary-color);
          .btn-text {
            color: var(--primary-color);
          }
        }
        .btn-text {
          font-size: 14px;
        }
      }
    }
  }
  .assets-total-box {
    display: flex;
    .assets-total-item {
      flex: 1;
      gap: 24px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        display: flex;
        align-items: center;
        img {
          cursor: pointer;
          width: 24px;
          height: 24px;
          margin-left: 22px;
        }
      }
      .p-info {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #2ebd85;
      }
    }
    .assets-total-item:first-child {
      border-right: 1px solid var(--line-border-color);
    }
    .asset-amount {
      display: flex;
      align-items: baseline;
      position: relative;

      .amount-value {
        font-size: 40px;
        font-weight: 700;
        color: #1f2329;
      }

      .currency-selector {
        display: flex;
        align-items: center;
        margin-left: 8px;
        cursor: pointer;
        position: relative;

        .amount-currency {
          font-size: 16px;
          color: #1f2329;
        }
        i {
          font-size: 16px;
        }
      }

      .currency-dropdown {
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        background-color: #ffffff;
        border-radius: 12px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        z-index: 100;
        min-width: 100px;

        .currency-option {
          padding: 12px 20px;
          text-align: center;

          &:first-child {
            border-radius: 12px 12px 0 0;
          }

          &:last-child {
            border-radius: 0 0 12px 12px;
          }

          &.active {
            background-color: #f0f5ff;

            .currency-text {
              color: var(--primary-color);
              font-weight: 600;
            }
          }

          .currency-text {
            font-size: 16px;
            color: #333333;
          }
        }
      }
    }
  }
}
.icon-de {
  width: 44px;
  height: 44px;
}

.exchange-card {
  background: var(--box-bg-color);
  border-radius: 16px;
  padding: 28px 32px;

  .exchange-content {
    display: flex;
    flex-direction: column;
  }

  .exchange-title {
    font-size: 20px;
    font-weight: 600;
    color: #1f2329;
    margin: 0 0 12px 0;
  }

  .exchange-rate {
    margin-bottom: 24px;

    .exchange-rate-text {
      font-size: 16px;
      color: var(--primary-color);
      font-weight: 600;
    }
  }

  .exchange-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .exchange-record {
    font-size: 14px;
    color: #999999;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: var(--primary-color);
    }
  }

  .exchange-btn {
    color: var(--white-color);
    background-color: var(--primary-color);
    border-radius: 10px;
    padding: 10px 28px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 4px 12px rgba(64, 99, 255, 0.3);
    }

    .exchange-btn-text {
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
</style>
